import Vue from 'vue'
import Money from 'js-money'
import store from '../store'

Vue.filter('money', value => {
  if (!value) {
    return
  }
  if (typeof value === 'object') {
    let amount = Money.fromInteger({ amount: parseInt(value.amount), currency: value.currency })

    return new Intl.NumberFormat(store.getters.locale, { style: 'currency', currency: value.currency }).format(amount)
  }

  value = isNaN(value) ? 0.00 : value

  return new Intl.NumberFormat(store.getters.locale, { style: 'currency', currency: store.getters.currency }).format(value)
})
